import { panelMotion } from "../lib/motion";

export function AnimatedCheck({ checked }: { checked: boolean }) {
  return (
    <span
      className={`flex size-[1.15rem] shrink-0 items-center justify-center rounded-[0.45rem] ${panelMotion} ${checked ? "bg-foreground text-background" : "bg-foreground/10 text-transparent"}`}
    >
      <svg viewBox="0 0 16 16" className="size-3.5" fill="none" aria-hidden="true">
        <path
          d="M3.5 8.5 6.75 11.75 12.5 4.75"
          stroke="currentColor"
          strokeWidth={2.25}
          strokeLinecap="round"
          strokeLinejoin="round"
          pathLength={1}
          strokeDasharray={1}
          strokeDashoffset={checked ? 0 : 1}
          className="transition-[stroke-dashoffset] duration-300 ease-[cubic-bezier(0.16,1,0.3,1)]"
        />
      </svg>
    </span>
  );
}
